module.exports = __webpack_public_path__ + "assets/instructionEmailChange-39938c70407a8ee206fcc0c248d74a27.pdf";